import React from 'react';

import { Box, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(2.5),
  },
  label: {
    marginBottom: theme.spacing(1),
    fontSize: 13,
    fontWeight: 700,
    letterSpacing: 0.3,
    textTransform: 'uppercase',
    color: 'rgba(18, 74, 104, 0.72)',
  },
  frameShell: {
    padding: theme.spacing(1),
    borderRadius: theme.borderRadiusBoxes?.borderRadius || 4,
    background:
      'linear-gradient(180deg, rgba(12, 49, 70, 0.96) 0%, rgba(19, 95, 130, 0.94) 100%)',
    boxShadow: '0 18px 34px rgba(10, 44, 63, 0.16)',
  },
  frame: {
    position: 'relative',
    width: '100%',
    paddingTop: '56.25%',
    borderRadius: theme.borderRadiusBoxes?.borderRadius || 4,
    overflow: 'hidden',
    backgroundColor: '#0b2433',
  },
  frameMobile: {
    maxWidth: 360,
    margin: '0 auto',
  },
  iframe: {
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    border: 0,
  },
}));

function Video({ title, videoId, mobile }) {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      {title && <Box className={classes.label}>{title}</Box>}
      <Box className={classes.frameShell}>
        <Box className={`${classes.frame} ${mobile ? classes.frameMobile : ''}`.trim()}>
          <iframe
            className={classes.iframe}
            src={`https://www.youtube.com/embed/${videoId}`}
            title={title || videoId}
            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
            allowFullScreen
          />
        </Box>
      </Box>
    </Box>
  );
}

export default Video;
